<template>
  <div class="history" v-if="showHistory">
    <div class="title">History</div>
    <div class="items">
      <copyable v-if="history.email" :text="history.email" />
      <copyable v-if="history.domain" :text="history.domain" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      email: '',
      domain: '',
    }
  },
  computed: {
    ...mapGetters(['history']),
    showHistory() {
      return this.history.email || this.history.domain
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@styles';
.history {
  font-weight: normal;
  padding: 0 10px;

  .title {
    font-size: 0.7em;
    @include themed {
      color: t(muted);
    }
  }
  .items {
    display: flex;
    font-weight: bold;
    font-size: 0.8em;
    > *:not(:last-child) {
      margin-right: 10px;
    }
  }

  @include themed {
    background: t(fg);
    color: t(text);
    border-left: 3px solid t(primary);
  }

  @media (max-width: $break-small) {
    display: none;
  }
}
</style>
